<template>
	<v-main>
		<!-- barra che non si stampa -->
		<div class="ip-toolbar no-print d-flex align-center px-4 py-2">
			<v-btn small text @click="back">
				<v-icon small left>mdi-arrow-left</v-icon>
				{{ backLabel }}
			</v-btn>
			<v-spacer />
			<span class="text-caption grey--text mr-3">Nella finestra di stampa puoi anche scegliere "Salva come PDF"</span>
			<v-btn small depressed color="primary" :disabled="!data || !data.lines.length" @click="stampa">
				<v-icon small left>mdi-printer</v-icon>
				Stampa / Salva PDF
			</v-btn>
		</div>

		<div class="ip-page">
			<v-skeleton-loader v-if="!data" type="article, table" />
			<template v-else>
				<header class="ip-header">
					<div>
						<div class="text-overline grey--text">Proposta d'ordine</div>
						<h1 class="ip-title">{{ data.supplier.name }}</h1>
						<div v-if="data.supplier.address" class="ip-muted">{{ data.supplier.address }}</div>
						<div class="ip-muted">
							<span v-if="data.supplier.vat">P.IVA {{ data.supplier.vat }}</span>
							<span v-if="data.supplier.email"> · {{ data.supplier.email }}</span>
							<span v-if="data.supplier.phone"> · {{ data.supplier.phone }}</span>
						</div>
					</div>
					<div class="text-right">
						<div class="font-weight-medium">{{ data.profile.name }}</div>
						<div class="ip-muted">{{ data.date | moment('DD/MM/YYYY') }}</div>
					</div>
				</header>

				<table class="ip-table">
					<thead>
						<tr>
							<th class="text-left">Prodotto</th>
							<th class="text-left">SKU</th>
							<th class="text-left">Cod. fornitore</th>
							<th class="text-right">Quantità</th>
							<th class="text-right">Costo unitario</th>
							<th class="text-right">Totale</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(l, i) in data.lines" :key="i" class="avoid-break">
							<td>{{ l.title }}</td>
							<td>{{ l.sku }}</td>
							<td>{{ l.supplierCode || '—' }}</td>
							<td class="text-right text-no-wrap">
								{{ num(l.qty) }} {{ l.unitLabel }}<span v-if="l.packageSize > 1" class="ip-muted"> ({{ num(l.qty / l.packageSize) }} × {{ l.packageSize }})</span>
							</td>
							<td class="text-right">{{ formatEurCents(l.cost) }}</td>
							<td class="text-right">{{ formatEurCents(l.total) }}</td>
						</tr>
						<tr v-if="!data.lines.length">
							<td colspan="6" class="text-center grey--text py-4">Nessun prodotto da ordinare a questo fornitore</td>
						</tr>
					</tbody>
					<tfoot v-if="data.lines.length">
						<tr>
							<td colspan="5" class="text-right font-weight-medium">Totale stimato (prezzi d'acquisto, IVA esclusa)</td>
							<td class="text-right font-weight-medium">{{ formatEurCents(data.total) }}</td>
						</tr>
					</tfoot>
				</table>
				<div class="ip-muted mt-4">{{ data.lines.length }} prodotti. Quantità calcolate dalle vendite e dalla stagionalità, eventualmente corrette a mano nel report scorte.</div>
			</template>
		</div>
	</v-main>
</template>

<script>
import { mapActions } from 'vuex';
import { returnInfo, goBackWithResult } from '@/components/core/pageReturn';
import { formatEurCents } from '@/components/finance/format';

const nf = new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 });

export default {
	name: 'FinanceInventoryPrint',
	data() {
		return { data: null, ret: returnInfo(this.$route) };
	},
	computed: {
		backLabel() {
			return this.ret ? this.ret.label : 'Torna al report scorte';
		},
	},
	async mounted() {
		try {
			this.data = await this.fetchPrint(this.$route.query.supplier || 'none');
		} catch (err) {
			this.$store.dispatch('settings/updateSnackbar', {
				color: 'error',
				text: (err.response && err.response.data && err.response.data.message) || err.message,
				snackbar: true,
				mode: 'multi-line',
				timeout: 5000,
			});
		}
	},
	methods: {
		...mapActions({ fetchPrint: 'finance/fetchInventoryPrint' }),
		formatEurCents,
		num: v => nf.format(+v || 0),
		stampa() {
			window.print();
		},
		back() {
			if (this.ret) goBackWithResult(this.$router, this.ret, '', null);
			else this.$router.push({ path: '/finance/inventory', query: { tab: 'reorder' } });
		},
	},
};
</script>

<style scoped>
.ip-toolbar {
	border-bottom: 1px solid #e1e7ef;
	background: #fff;
}
.ip-page {
	max-width: 1000px;
	margin: 0 auto;
	padding: 24px;
}
.ip-header {
	display: flex;
	justify-content: space-between;
	gap: 24px;
	margin-bottom: 20px;
}
.ip-title {
	font-size: 22px;
	font-weight: 600;
}
.ip-muted {
	font-size: 12px;
	color: #5f6b7a;
}
.ip-table {
	width: 100%;
	border-collapse: collapse;
	font-size: 13px;
}
.ip-table th,
.ip-table td {
	padding: 6px 8px;
	border-bottom: 1px solid #e0e0e0;
}
.ip-table th {
	font-size: 12px;
	color: #5f6b7a;
	font-weight: 500;
}
</style>

<style>
@media print {
	@page {
		size: A4;
		margin: 12mm;
	}
	.no-print,
	.v-navigation-drawer,
	.v-app-bar,
	.v-footer {
		display: none !important;
	}
	.v-main {
		padding: 0 !important;
	}
	.ip-page {
		max-width: none !important;
		padding: 0 !important;
	}
	.avoid-break {
		break-inside: avoid;
		page-break-inside: avoid;
	}
}
</style>
